/** Public action link: shared button behavior with the existing public palette. */
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CtaLinkProps {
  to: string;
  variant?: "primary" | "ghost";
  caret?: boolean;
  className?: string;
  children: React.ReactNode;
}

const VARIANTS = {
  primary: "bg-[var(--public-primary)] text-[var(--public-on-inverse)] shadow-[inset_0_0_0_1px_color-mix(in_oklab,var(--public-highlight)_60%,transparent),0_1px_0_var(--public-primary-deep)] hover:bg-[var(--public-primary-deep)]",
  ghost:
    "border-[var(--public-foreground-soft)] bg-transparent text-[var(--public-foreground)] hover:bg-[var(--public-surface)] hover:text-[var(--public-primary)]",
} as const;

export function CtaLink({ to, variant = "primary", caret = false, className, children }: CtaLinkProps) {
  const classes = cn("text-ui", VARIANTS[variant], className);

  const body = (
    <>
      {children}
      {caret && (
        <span className="-translate-y-px font-display text-[17px] italic tracking-normal">›</span>
      )}
    </>
  );

  return (
    <Button asChild variant={variant === "primary" ? "default" : "outline"} className={classes}>
      {to.startsWith("#") ? <a href={to}>{body}</a> : <Link to={to}>{body}</Link>}
    </Button>
  );
}
